import React from 'react'
import {Button, Table} from 'antd'
import {DndProvider, DragSource, DropTarget} from 'react-dnd'
import {HTML5Backend} from 'react-dnd-html5-backend'
import update from 'immutability-helper'
import {withTranslation} from 'react-i18next'
import {inject, observer} from 'mobx-react'
import {withRouter} from 'react-router-dom'

let dragingIndex = -1

class BodyRow extends React.Component {
  render() {
    const {isOver, connectDragSource, connectDropTarget, moveRow, ...restProps} = this.props
    const style = {...restProps.style, cursor: 'move'}

    let {className} = restProps
    if (isOver) {
      if (restProps.index > dragingIndex) {
        className += ' drop-over-downward'
      }
      if (restProps.index < dragingIndex) {
        className += ' drop-over-upward'
      }
    }

    return connectDragSource(
      connectDropTarget(<tr {...restProps} className={className} style={style}/>),
    )
  }
}

const rowSource = {
  beginDrag(props) {
    dragingIndex = props.index
    return {
      index: props.index,
    }
  },
}

const rowTarget = {
  drop(props, monitor) {
    const dragIndex = monitor.getItem().index
    const hoverIndex = props.index

    // Don't replace items with themselves
    if (dragIndex === hoverIndex) {
      return
    }

    // Time to actually perform the action
    props.moveRow(dragIndex, hoverIndex)

    // Note: we're mutating the monitor item here!
    // Generally it's better to avoid mutations,
    // but it's good here for the sake of performance
    // to avoid expensive index searches.
    monitor.getItem().index = hoverIndex
  },
}

const DragableBodyRow = DropTarget('row', rowTarget, (connect, monitor) => ({
  connectDropTarget: connect.dropTarget(),
  isOver: monitor.isOver(),
}))(
  DragSource('row', rowSource, connect => ({
    connectDragSource: connect.dragSource(),
  }))(BodyRow),
)

const columns = [
  {
    title: '全选',
    dataIndex: 'name',
    key: 'name',
  },
]

@inject('reportManagementStore')
@observer
class PopTable extends React.Component {
  state = {
    selectedRowKeys: [],
    data: [],
  }

  components = {
    body: {
      row: DragableBodyRow,
    },
  }

  moveRow = (dragIndex, hoverIndex) => {
    const {data} = this.state
    const dragRow = data[dragIndex]

    this.setState(
      update(this.state, {
        data: {
          $splice: [[dragIndex, 1], [hoverIndex, 0, dragRow]],
        },
      }),
    )
  }

  getRowClassName = (record, index) => {
    let className
    className = index % 2 === 0 ? 'oddRow' : 'evenRow'
    return className
  }

  onSelectChange = newSelectedRowKeys => {
    this.setState({selectedRowKeys: newSelectedRowKeys})
  }

  saveReportConfig = () => {
    const {reportManagementStore, onSearch, onOpenChange, match} = this.props
    const {selectedRowKeys, data} = this.state
    
    // 优先从URL参数获取reportId
    let reportId = null;
    if (match && match.params && match.params.id) {
      reportId = Number(match.params.id);
    } else {
      // 向后兼容：从localStorage获取
      const selectedItem = localStorage.getItem('selectedItem');
      if (selectedItem) {
        reportId = Number(selectedItem.split(',')[0]);
      }
    }
    
    const params = {
      reportId,
      config: data.map(item => {
        item.show = selectedRowKeys.includes(item.name)
        return item
      })
    }

    reportManagementStore.saveReportConfig(params).then(res => {
      if (res?.code === 0) {
        onOpenChange(false)
        onSearch(1, 10)
      }
    })
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const {popTableData} = this.props

    if (prevProps.popTableData !== popTableData) {
      this.setState({
        data: popTableData,
        selectedRowKeys: popTableData.filter(item => item.show).map(item => item.name),
      })
    }
  }

  render() {
    const {t, popTableLoading, onOpenChange} = this.props
    const {selectedRowKeys, data} = this.state
    const rowSelection = {
      selectedRowKeys,
      onChange: this.onSelectChange,
    }

    return (
      <DndProvider backend={HTML5Backend}>
        <Table
          id="components-table-demo-drag-sorting"
          columns={columns}
          dataSource={data}
          // showHeader={false}
          pagination={false}
          className="report-pop-table"
          components={this.components}
          rowClassName={this.getRowClassName}
          scroll={{y: '345px'}}
          rowSelection={rowSelection}
          loading={popTableLoading}
          onRow={(record, index) => ({
            index,
            moveRow: this.moveRow,
          })}
        />
        <div style={{textAlign: 'right'}}>
          <Button onClick={this.saveReportConfig} style={{marginTop: '10px',marginRight:'10px'}} type='danger'>{t(`general.ok`)}</Button>
          <Button onClick={() => onOpenChange(false)} style={{marginTop: '10px'}}>{t(`general.cancel`)}</Button>
        </div>
      </DndProvider>
    )
  }
}

export default withRouter(withTranslation()(PopTable))